import { Box, Paper, Typography } from "@mui/material";
import { useWatch } from "react-hook-form";
import { fileSrc } from "../fileUpload";
import { PHRASE_TEXT_PALETTE } from "./HexColorInput";

function normalizeHex(value: unknown, fallback: string): string {
  if (typeof value !== "string") return fallback;
  const trimmed = value.trim();
  if (/^#([0-9A-Fa-f]{6})$/.test(trimmed)) return trimmed.toUpperCase();
  if (/^([0-9A-Fa-f]{6})$/.test(trimmed)) return `#${trimmed.toUpperCase()}`;
  return fallback;
}

export default function PhraseCardPreview() {
  const textColor = useWatch({ name: "TextColor" }) as string | undefined;
  const phraseRu = useWatch({ name: "PhraseRU" }) as string | undefined;
  const phraseAz = useWatch({ name: "PhraseAZ" }) as string | undefined;
  const phraseLegacy = useWatch({ name: "Phrase" }) as string | undefined;
  const backgroundRu = useWatch({ name: "BackgroundRU" }) as string | undefined;
  const backgroundAz = useWatch({ name: "BackgroundAZ" }) as string | undefined;
  const backgroundLegacy = useWatch({ name: "Background" }) as string | undefined;

  const phrase =
    phraseRu?.trim() || phraseAz?.trim() || phraseLegacy?.trim() || "Мотивационная фраза";
  const backgroundUrl =
    fileSrc(backgroundRu) || fileSrc(backgroundAz) || fileSrc(backgroundLegacy);

  const color = normalizeHex(textColor, "#FFFFFF");
  const hasBackground = Boolean(backgroundUrl);

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        borderRadius: 2,
        bgcolor: hasBackground ? "grey.100" : "background.paper",
      }}>
      <Typography variant="subtitle2" gutterBottom>
        Превью слайда
      </Typography>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          maxWidth: 420,
          mx: "auto",
          aspectRatio: "2 / 1",
          borderRadius: 2.5,
          overflow: "hidden",
          border: "1px solid",
          borderColor: "divider",
          bgcolor: hasBackground ? "grey.300" : "#E8F4FF",
          backgroundImage: backgroundUrl ? `url(${backgroundUrl})` : undefined,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 2,
        }}>
        {!hasBackground && (
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              bgcolor: "rgba(255,255,255,0.35)",
            }}
          />
        )}
        {hasBackground && (
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              bgcolor: "rgba(0,0,0,0.08)",
            }}
          />
        )}
        <Typography
          align="center"
          sx={{
            position: "relative",
            zIndex: 1,
            color,
            fontWeight: 500,
            fontSize: "1.05rem",
            lineHeight: 1.35,
            textShadow:
              color === "#FFFFFF" || color === PHRASE_TEXT_PALETTE[8]
                ? "0 1px 6px rgba(0,0,0,0.45)"
                : "0 1px 4px rgba(255,255,255,0.55)",
            maxWidth: "82%",
          }}>
          {phrase}
        </Typography>
      </Box>
      {!hasBackground && (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: "block" }}>
          Загрузите фон, чтобы увидеть контраст текста на картинке
        </Typography>
      )}
    </Paper>
  );
}
